/**
 * Geo IP
 * -------------------------------------------------------
 * Detects location of user and offers a more suitable website if one is available.  
 * 
 * -------------------------------------------------------
 **/

 import IPGeo from '@bva/ipgeo'

 import {
     registerLegacySalvoLiteComponent,
     legacySalvoLiteLog as log
 } from '@eastsideco/salvo-ts';
 
 class GeoIp {
     constructor (theme, elem) {
        this._theme = theme;
        this._elem = elem;
        this.onInit();
        this.geoIP = document.querySelector('[data-geo-ip]');
        this.geoIPClose = document.querySelectorAll('[data-geo-ip-close]');
        this.geoIPSubTitle = document.querySelector('[data-geo-ip-sub-title]');
        this.geoIPRedirect = document.querySelector('[data-geo-ip-redirect]');
        this.geoIPCurrent = document.querySelector('[data-geo-ip-current]');
        this.countryData = JSON.parse(document.getElementById('geo-ip-country-data').textContent);
     }
     onInit () {

        const GeoIPSeen = localStorage.getItem('geo-ip');

        if (GeoIPSeen === 'seen') return 

        const geo = new IPGeo();
        geo.getGeo().then(data => {
            let newCountry = false;
            let currentCountry = false;
            this.countryData.forEach(element => {  
                if (data.country_code === element.countryCode) {
                    // create new country if in wrong place
                    newCountry = element;
                }        
            });
            // find country u should be visiting... 
            this.countryData.forEach(element => {
                if (window.location.origin === element.countryUrl) {
                    currentCountry = element;
                }
            });
            if (newCountry && currentCountry) {
                if (newCountry.countryUrl !== window.location.origin) {
                    this.openPopUp();
                    this.closePopUp();
                    this.updatePopUp(newCountry, currentCountry);
                }
            }
        });
    }

    updatePopUp (newCountry, currentCountry) {
        this.geoIPRedirect.addEventListener('click', (e) => {
            window.location = newCountry.countryUrl;
        });

        // this copy is pulled from theme settings and then adapted.
        if (this.geoIPSubTitle != null) {
            const replaceCountry = this.geoIPSubTitle.innerText.replace('(country)', newCountry.countryName);
            const replaceCode = replaceCountry.replace('(code)', newCountry.countryCodeAlternate);
            this.geoIPSubTitle.innerText = replaceCode;
        }

        let newBtnImg;
        let newBtnCopy;
        if (this.geoIPRedirect != null) {
            newBtnImg = this.geoIPRedirect.querySelector('.geo-ip__button--image');
            newBtnCopy = this.geoIPRedirect.querySelector('.geo-ip__button--copy');
        }

        if (newBtnImg != null && newBtnCopy != null) {
            newBtnImg.src = newCountry.countryImage;
            newBtnCopy.innerText = `Visit ${newCountry.countryCodeAlternate} store (${newCountry.countryCurrency})`;
        }

        let currentBtnImg;
        let currentBtnCopy;
        if (this.geoIPCurrent != null) {
            currentBtnImg = this.geoIPCurrent.querySelector('.geo-ip__button--image');
            currentBtnCopy = this.geoIPCurrent.querySelector('.geo-ip__button--copy');
        }

        if (currentBtnCopy != null && currentBtnImg != null) {
            currentBtnImg.src = currentCountry.countryImage;
            currentBtnCopy.innerText = `Stay on ${currentCountry.countryCode} store (${currentCountry.countryCurrency})`;
        }
    }

    closePopUp () {
        localStorage.setItem('geo-ip', 'seen');
        this.geoIPClose.forEach(element => {
            element.addEventListener('click', (e) => {
                document.body.classList.remove('no-scroll');
                this.geoIP.classList.add('hidden');
            });
        })
    }

    openPopUp () {
        document.body.classList.add('no-scroll');
        this.geoIP.classList.remove('hidden');
    }
 }
 
 export default registerLegacySalvoLiteComponent({
     component: GeoIp,
     selector: '[data-geo-ip]', // Required
 });
 